var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_c('audio',{ref:"bgMusic",attrs:{"id":"bgMusic","src":"https://xmf-pigeon.oss-cn-hangzhou.aliyuncs.com/public/5c894e8c6b62443588.mp3"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }